import type { ButtonKind } from 'components/design-system/BreakoutButton'
import { BreakoutButtonLink } from 'components/design-system/BreakoutButton'

/**
 * The user-driven half of leaving an iframe: a real link the user clicks
 * themselves, so no popup blocker can interfere. Pair with
 * `navigateOutsideIframe` from `util/iframe`, which handles the automatic
 * half.
 */
export function OpenOutsideIframeButton({
  href,
  children,
  kind = 'accent',
  className,
  onClick,
  testId,
}: {
  href: string
  children: React.ReactNode
  kind?: ButtonKind
  className?: string
  onClick?: React.MouseEventHandler<HTMLAnchorElement>
  testId?: string
}) {
  return (
    <BreakoutButtonLink
      className={className}
      kind={kind}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
      testId={testId}
    >
      {children}
    </BreakoutButtonLink>
  )
}
